import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  checkRevertFundPayment,
  revertFundPayment,
} from '../../../../../../../lib/api/funds';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';
import { showAlert } from '../../../../../../../lib/functions/utils';

const RevertPaymentDialog = (props: any) => {
  const { open, setOpen, payment, bigSetUp } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [canRevert, setCanRevert] = useState(false);
  const [reason, setReason] = useState('');
  const [warningMessages, setWarningMessages] = useState<string[]>([]);

  const setUp = async () => {
    setLoading(true);
    try {
      const response = await checkRevertFundPayment(dispatch, {
        id: payment.id,
      });
      setCanRevert(response.canRevert);
      setReason(response.reason);
      setWarningMessages(response.warningMessages);
    } catch (error) {
      showAlert(
        dispatch,
        'error',
        'Error al evaluar si se puede reversar el pago',
      );
    }
    setLoading(false);
  };

  const handleRevertPayment = async () => {
    setLoading(true);
    try {
      await revertFundPayment(dispatch, { id: payment.id });
      showAlert(dispatch, 'success', 'Pago reversado correctamente');
      void bigSetUp();
      setOpen(false);
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al reversar el pago');
    }
    setLoading(false);
  };

  useEffect(() => {
    void setUp();
  }, [open]);

  return (
    <Dialog open={open}>
      <DialogTitle>
        Reversar aviso de pago #{payment.id} folio {payment.folio} del fondo{' '}
        {payment.fundName}
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '100px',
            }}
          >
            <CenteredCircularProgress type="dialog" />
          </div>
        ) : (
          <>
            <Typography variant="body1">
              ¿Estás seguro que quieres reversar este pago? Se ejecutarán las
              siguientes acciones:
            </Typography>
            <div style={{ padding: '10px 0px' }}>
              {warningMessages.map((message) => (
                <Typography key={message} variant="body1" color="error">
                  - {message}
                </Typography>
              ))}
            </div>
            {!canRevert && reason && (
              <div style={{ padding: '10px 0px', marginTop: '10px' }}>
                <Typography variant="body1" color="error">
                  {reason}
                </Typography>
              </div>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          color="secondary"
          onClick={() => setOpen(false)}
          disabled={loading}
        >
          Cancelar
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={handleRevertPayment}
          disabled={!canRevert || loading}
        >
          Reversar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default RevertPaymentDialog;
